import React from "react";
import { Upload } from "antd";
import { CloudUploadIcon } from "../svgs";
import { observer } from "mobx-react-lite";
import { useStore } from "../../store";
import { serverUrl } from "../../stores";

type DragAndDropProps = {
  title?: string;
};

const DragAndDrop: React.FC<DragAndDropProps> = observer((props) => {
  const { quotesStore } = useStore();
  const { setFile } = quotesStore;

  const handleChange = (info: any) => {
    if (info.file && info.file.status === "done") {
      setFile({
        originalName: info.file.originFileObj.name,
        bucketPath: info.file.response.bucketPath,
        downloadURL: info.file.response.downloadURL,
      });
    }
  };

  return (
    <div className="mt-2">
      <Upload.Dragger
        action={`${serverUrl}/upload`}
        onChange={handleChange}
        multiple
      >
        <div className="flex-col justify-center items-center mt-2">
          <CloudUploadIcon />
          <p className="ant-upload-text">
            Drag and drop to upload a file <br /> or
          </p>
          <p className="border-danger font-danger w-fit rounded-8 py-2 px-8 mt-2 mb-4 font-bold hover-danger">
            Choose File
          </p>
        </div>
      </Upload.Dragger>
    </div>
  );
});

export default DragAndDrop;
